import * as React from "react";
import cn from "classnames";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useColor } from "components/utils/color";
import Color from "color";

type DataGridCellBadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
    item: string;
    showTooltip?: boolean;
};

export const DataGridCellBadge: React.FC<DataGridCellBadgeProps> = ({ item, showTooltip = false, className, style, ...props }) => {
    let primaryColor = useColor("primary");
    const isPrimaryColorLight = Color(style?.backgroundColor ?? primaryColor).isLight();
    const textColor = isPrimaryColorLight ? "var(--bs-dark)" : "var(--bs-light)";

    return (
        <OverlayTrigger
            overlay={
                showTooltip ? (
                    <Tooltip>
                        <span className={"text-white"}>{item}</span>
                    </Tooltip>
                ) : (
                    <></>
                )
            }
        >
            <span
                {...props}
                style={{ ...style, color: style?.color ?? textColor }}
                className={cn("fs-8 badge", { "bg-primary": !style?.backgroundColor }, className)}
            >
                {item}
            </span>
        </OverlayTrigger>
    );
};
